module.exports = __webpack_public_path__ + "common/images/footer-water.jpg";


//////////////////
// WEBPACK FOOTER
// ./common/images/footer-water.jpg
// module id = 27
// module chunks = 0 1 2 3 4 5 6 7